import React, { FunctionComponent } from "react";
import { Form, Rate } from "antd";
import FormLabel from "./FormLabel";
import styles from "../BiformLayout.module.scss";
import { QuestionComponentProps } from "../helper";

// RATING — star rating; the star count comes from validation.maxRating (default 5).
const StarRating: FunctionComponent<QuestionComponentProps> = ({ question, disabled = false }) => {
  const maxRating = typeof question.validation?.maxRating === "number" ? question.validation.maxRating : 5;

  return (
    <Form.Item
      name={question.id}
      label={<FormLabel label={question.label} required={question.isRequired} description={question.description} />}
      rules={[{ required: question.isRequired, message: "Please select your rating" }]}
    >
      {/* allowHalf so a decimal rating (e.g. 2.5) is shown exactly. */}
      <Rate allowHalf disabled={disabled} count={maxRating} className={styles.rating} />
    </Form.Item>
  );
};

export default StarRating;
